import MDBox from "../../../Components/MDBox";
import {Grid} from "@mui/material";
import Avatar from "@mui/material/Avatar";
import {CurrentUser} from "../../../utils/Hooks/currentUser";
import MDTypography from "../../../Components/MDTypography";
import {useNavigate} from "react-router-dom";
import Cookies from "js-cookie";

const HeroLayout = ({children,Showdesc=true}) => {
    const navigate = useNavigate()

    function handleExit() {
        Cookies.remove("cst")
        Cookies.remove("ut")
        navigate("/")   
    }

    return <MDBox bgColor={"#A7EAFB"} minHeight={"100vh"}>
        <MDBox bgColor={"#C6F3FF"} minHeight={"100vh"} mx={{xs: 0, lg: 20,sm:10}}>
            {Showdesc&&
            <Grid container p={2}>
                <Grid container item direction={"column"} xs={2} alignItems={"center"} gap={1}>
                    <Grid item>
                        <Avatar sx={{width: 80, height: 80}}>{CurrentUser().user.FullName}</Avatar>
                    </Grid>
                    <Grid item><MDTypography>{CurrentUser().user.FullName}</MDTypography></Grid>
                </Grid>
                <Grid item xs={8} textAlign={"center"} alignContent={"center"}  onClick={() => navigate("/studentlanding")}><MDTypography
                    sx={{fontFamily: "lale", color: "#001670",fontSize:"4rem"}}>
                    قهرمان سلامت
                </MDTypography></Grid>
                <Grid   item direction={"column"} xs={2} alignItems={"center"} alignSelf={"center"} gap={1}>
                
                     <MDTypography sx={{fontFamily: "lale", color: "red"}} onClick={() => handleExit()}>خروج</MDTypography> 
                </Grid>
            </Grid>
            }
            <MDBox>
                {children}
            </MDBox>
        </MDBox>

    </MDBox>
}

export default HeroLayout